import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { environment } from 'src/environments/environment';

/** Web OAuth client for Google sign-in (from environment). */
export const firebaseGoogleWebClientId = environment.firebaseGoogleWebClientId;

const firebaseConfig = environment.firebaseConfig;

const app = initializeApp(firebaseConfig);

const analytics = getAnalytics(app);

export const database = getDatabase(app);

export const db = initializeFirestore(app, {
  ignoreUndefinedProperties: true
});

export const firebaseApp = app;

export const storage = getStorage(app);
